var map = {
	"./angiodysplasia.svg": [
		8337,
		337
	],
	"./crohns_disease.svg": [
		1503,
		503
	],
	"./diverticulosis.svg": [
		6706,
		706
	],
	"./extent_of_examination.svg": [
		148,
		148
	],
	"./general_biopsy.svg": [
		8679,
		679
	],
	"./hemorrhoids.svg": [
		7615,
		615
	],
	"./malignant_tumor.svg": [
		1620,
		620
	],
	"./medication.svg": [
		1024,
		24
	],
	"./polyp.svg": [
		7684,
		684
	],
	"./preparation.svg": [
		5193,
		193
	],
	"./procedure_details.svg": [
		6097,
		97
	],
	"./staff.svg": [
		6092,
		92
	],
	"./ulcerative_colitis.svg": [
		1499,
		499
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 9415;
module.exports = webpackAsyncContext;